export default __webpack_public_path__ + "assets/img/sad_lemon.29242f31ec4c7ea8bdace224c64ef4ed.png";